import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";

import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import banner4 from "../assets/banner4.jpg";
import overlay from "../assets/overlay.jpg";
import logo_icon from "../assets/logo.png";

export default function AboutUsContent() {
  const [ready, setReady] = useState(false);
  const [bgIndex, setBgIndex] = useState(0);

  const banners = [banner1, banner2, banner3, banner4];

  useEffect(() => {
    setReady(true);
  }, []);

  useEffect(() => {
    if (!ready) return;
    const interval = setInterval(() => {
      setBgIndex((prev) => (prev + 1) % banners.length);
    }, 3500);
    return () => clearInterval(interval);
  }, [ready]);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section className="MainBodySection" >

      {/* HERO / INTRO */}
      <div
        style={{
          backgroundImage: `url(${banners[bgIndex]})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          transition: "background-image 1.2s ease-in-out",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(180deg, rgba(0,0,0,0.65), rgba(0,0,0,0.75))",
          }}
        />

        <div className="container position-relative py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10">

              <div
                className="p-5 text-center"
                style={{
                  background: "rgba(255,255,255,0.92)",
                  borderRadius: "24px",
                  boxShadow: "0 25px 60px rgba(0,0,0,0.25)",
                }}
              >
                <img
                  src={logo_icon}
                  alt="Kitchen Kings TZ"
                  height={250}
                  className="mb-4"
                />

                <h1 className="font-bold text-primary mb-4">
                  Kitchen Kings TZ
                </h1>

                <p
                  className="text-dark"
                  style={{
                    fontSize: "1.05rem",
                    lineHeight: 1.9,
                    textAlign: "left",
                  }}
                >
                  Welcome to <strong>Kitchen Kings TZ</strong>, where quality craftsmanship meets
                  innovative design. As one of the leading providers of kitchen cabinets,
                  bar and restaurant furniture, and furnishing materials in Mwanza, Tanzania,
                  we specialize in transforming ordinary spaces into functional, elegant,
                  and long-lasting environments.
                  <br /><br />
                  We serve both residential and commercial clients, offering customized
                  solutions tailored to each project. At Kitchen Kings TZ, we understand
                  that every space has its own personality and purpose. That is why we take
                  a personalized approach—working closely with our clients to bring their
                  vision to life, whether it is a home renovation, a new restaurant setup,
                  or custom wooden furniture.
                  <br /><br />
                  Quality is at the heart of everything we do. We source premium materials
                  and employ skilled craftsmen to ensure our products are durable,
                  visually appealing, and built to last. Our commitment extends beyond
                  manufacturing to customer service, where we provide attentive support
                  throughout every stage of the project.
                  <br /><br />
                  Sustainability is a key pillar of our operations. We believe in responsible
                  sourcing, reducing waste, and adopting practices that minimize
                  environmental impact while maintaining the highest standards of
                  craftsmanship.
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* MISSION & VISION */}
      <div
        style={{
          backgroundImage: `url(${overlay})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "90px 0",
        }}
      >
        <div className="container">
          <div className="row g-5">

            {/* Mission */}
            <div className="col-md-6">
              <div
                className="h-100 p-5"
                style={{
                  background: "#ffffff",
                  borderRadius: "22px",
                  boxShadow: "0 18px 45px rgba(0,0,0,0.12)",
                }}
              >
                <h3 className="font-bold text-primary mb-3">
                  Our Mission
                </h3>
                <p style={{ lineHeight: 1.8 }}>
                  At Kitchen Kings TZ, our mission is to transform spaces into welcoming,
                  functional, and aesthetically pleasing environments. We aim to be the
                  trusted partner for individuals, businesses, and organizations seeking
                  high-quality kitchen cabinets, bar and restaurant furniture, and other
                  furnishing materials. Through craftsmanship, innovation, and exceptional
                  customer service, we create products that enhance everyday living.
                </p>
              </div>
            </div>

            {/* Vision */}
            <div className="col-md-6">
              <div
                className="h-100 p-5"
                style={{
                  background: "#ffffff",
                  borderRadius: "22px",
                  boxShadow: "0 18px 45px rgba(0,0,0,0.12)",
                }}
              >
                <h3 className="font-bold text-primary mb-3">
                  Our Vision
                </h3>
                <p style={{ lineHeight: 1.8 }}>
                  Our vision is to become a leading name in the furnishing and interior
                  design industry in East Africa and beyond. We aspire to set new standards
                  for quality, innovation, and customer satisfaction while making a positive
                  impact on our community and the environment through sustainable and
                  responsible business practices.
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>

    </section>
  );
}
